import css from 'styled-jsx/css';

export default css`
  /*
    The input cannot be hidden, otherwise text selection will not work.
    Move it offscreen as a workaround...
  */
  input {
    left: -999em;
    position: absolute;
    top: -999em;
  }

  .CopyLinkAction :global(.Tooltip) {
    color: #000;
    top: 1.2rem;
    right: -1.1rem;
  }

  .CopyLinkAction :global(.Tooltip::after) {
    right: 1rem;
    left: auto;
    transform: none;
  }
`;
